import { computed } from "vue";
import useCreateComponentConfig from "../../../composables/useCreateComponentConfig.js";
var ETabsElements = /* @__PURE__ */ ((ETabsElements2) => {
  ETabsElements2["INDICATOR"] = "INDICATOR";
  return ETabsElements2;
})(ETabsElements || {});
export default function useTabsConfig() {
  const indicatorClasses = useIndicatorConfig();
  return {
    indicatorClasses
  };
}
function useIndicatorConfig() {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    "INDICATOR" /* INDICATOR */,
    /* tw */
    `bg-brand-accent-invert absolute -bottom-[2px] left-0 h-[2px] w-[--radix-tabs-indicator-size] translate-x-[--radix-tabs-indicator-position] transition-[width,transform] duration-300`
  );
  const tabsClasses = computed(() => {
    return getClasses("INDICATOR" /* INDICATOR */);
  });
  return tabsClasses.value;
}
